"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _UIHeader = _interopRequireDefault(require("../layout/UIHeader"));

function UISubheader(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "className"]);
  return _react.default.createElement(_UIHeader.default, (0, _extends2.default)({}, rest, {
    className: (0, _classNames.default)('private-header--subheader', className),
    fullWidth: true,
    flush: true,
    use: "condensed"
  }), children);
}

UISubheader.propTypes = (0, _extends2.default)({}, (0, _omit.default)(_UIHeader.default.propTypes, ['flush', 'fullWidth', 'headingLevel', 'use']), {
  headingLevel: _react.PropTypes.oneOf(['h2', 'h3', 'h4', 'h5', 'h6'])
});
UISubheader.defaultProps = {
  headingLevel: 'h2',
  role: 'presentation'
};
UISubheader.displayName = 'UISubheader';
var _default = UISubheader;
exports.default = _default;
module.exports = exports.default;